import { render } from "./SchoolTypeTabs.vue?vue&type=template&id=5536f052&scoped=true&ts=true"
import script from "./SchoolTypeTabs.vue?vue&type=script&lang=ts"
export * from "./SchoolTypeTabs.vue?vue&type=script&lang=ts"

import "./SchoolTypeTabs.vue?vue&type=style&index=0&id=5536f052&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5536f052"]])

export default __exports__